function resetLoreDrawerScroll(modal) {
  if (!modal) return;

  const drawer = modal.querySelector('.mm-snes-lore__drawer');
  const inner = modal.querySelector('.mm-snes-lore__inner');
  const body = modal.querySelector('.mm-snes-lore__body');

  const reset = () => {
    if (modal) modal.scrollTop = 0;
    if (drawer) drawer.scrollTop = 0;
    if (inner) inner.scrollTop = 0;
    if (body) body.scrollTop = 0;
  };

  reset();
  requestAnimationFrame(reset);
  setTimeout(reset, 50);
  setTimeout(reset, 150);

  if (drawer) {
    drawer.focus({ preventScroll: true });
  }
}

document.addEventListener('click', function (event) {
  const openBtn = event.target.closest('[data-snes-lore-open]');
  const closeBtn = event.target.closest('[data-snes-lore-close]');

  if (openBtn) {
    const id = openBtn.getAttribute('data-snes-lore-open');
    const modal = document.getElementById(id);

    if (modal) {
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mm-snes-lore-open');
      openBtn.setAttribute('aria-expanded', 'true');

      resetLoreDrawerScroll(modal);
    }
  }

  if (closeBtn) {
    const id = closeBtn.getAttribute('data-snes-lore-close');
    const modal = document.getElementById(id);

    if (modal) {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mm-snes-lore-open');

      const opener = document.querySelector('[data-snes-lore-open="' + id + '"]');
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
      }

      resetLoreDrawerScroll(modal);
    }
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    const openLore = document.querySelector('.mm-snes-lore[aria-hidden="false"]');

    if (openLore) {
      openLore.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mm-snes-lore-open');

      const opener = document.querySelector('[data-snes-lore-open="' + openLore.id + '"]');
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
      }

      resetLoreDrawerScroll(openLore);
    }
  }
});